
import { defineComponent } from '@nuxtjs/composition-api';
import JobsPlaceholder from '@/components/partials/jobs/JobsPlaceholder/JobsPlaceholder.vue';
import BravadoRightNavigation from '@/components/common/BravadoRightNavigation/BravadoRightNavigation.vue';
import JobsTooltipsMixin from '@/components/partials/jobs/JobsProfile/JobsTooltipsMixin';
import { REFERER_IS_JOB_POSTING_LINK } from '~/components/partials/jobs/constants';

const JOB_POSTING_UTM_SOURCES = ['linkedin', 'indeed'];
const JOB_POSTING_UTM_MEDIUM = 'jobposting';

export default defineComponent({
  components: {
    JobsPlaceholder,
    BravadoRightNavigation,
  },
  mixins: [JobsTooltipsMixin],
  middleware: [
    ({ $auth, app, route }) => {
      if (!$auth.loggedIn) return;
      if (!route.query.dynamic_modal) return;
      if (route.query.dynamic_modal !== 'sign-up') return;

      app.$utils.redirectWithQuery({ path: route.path }, { query: { ...route.query, dynamic_modal: undefined } });
    },
  ],
  head() {
    return this.$seo({
      canonical: `${process.env.internalBaseUrl}/jobs/welcome`,
      title: 'Bravado Jobs - find tech sales job',
      description:
        "Tired of being underpaid, selling a product that can’t compete? We're sick and tired of it. So we decided to vet every sales org for you! Welcome to Bravado Jobs!",
    });
  },
  computed: {
    refererIsJobPostingLink(): boolean {
      const { utm_source, utm_medium } = this.$route.query as Record<string, string | undefined>;
      if (utm_source && utm_medium) {
        return JOB_POSTING_UTM_SOURCES.some(
          source => utm_source.toLowerCase() === source && utm_medium.toLowerCase() === JOB_POSTING_UTM_MEDIUM,
        );
      }
      return document.referrer.includes('jobs.bravado.co') || document.referrer.includes('https://bravado.co/lp/jobs');
    },
  },
  mounted() {
    this.persistSkipOnboardingJobSteps();
  },
  methods: {
    persistSkipOnboardingJobSteps(): void {
      if (!this.$cookies.get(REFERER_IS_JOB_POSTING_LINK) && this.refererIsJobPostingLink) {
        this.$cookies.set(REFERER_IS_JOB_POSTING_LINK, true, {
          maxAge: 60 * 60 * 24 * 30, // 30 days expiry
          path: '/',
        });
      }
    },
  },
});
